import intl from 'react-intl-universal';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Space, Input, message, Spin, Modal } from 'antd';
import { Icon } from '@/components';

// import { Button, Modal } from '@/components';
import SoftPhoneUtils from '@/utils/softPhoneUtils';
import Timer from './components/timer';
import style from './index.less';
import KeyBoard from './components/keyboard';
import Status from './components/ChangeStatus';
import { isFunction } from 'lodash';
import { useModel, history } from '@umijs/max';
import {
    getAgentDetail,
    getQueueStatus,
    getPausesStatus,
    recordCall,
} from '@/api/softPhone';
// import Login from './components/login';
import TransferToNode from './components/transferToNode';
import TransferToMember from './components/transferToMember';

// interface Props {}

const SoftPhone: React.FC = () => {
    const {
        initialState: { userInfo = {} },
    } = useModel('@@initialState');
    const sessionId = useRef<string>();
    const popId = useRef<string>();
    //  2: 'ip话机',
    //  3: '软电话',
    const [phoneType, setPhoneType] = useState<number>();
    // const [softPhoneUtils, setsoftPhoneUtils] = useState<SoftPhoneUtils>();
    const [status, setStatus] = useState<string>(intl.get('空闲'));
    const [showKeyBoard, setShowKeyBoard] = useState<boolean>(false);
    const [pauseStatus, setPauseStatus] = useState<any[]>([]);
    // 是否登陆
    const [isLogin, setIsLogin] = useState<boolean>(false);
    // 手机号输入框值
    const [callPhone, setCallPhone] = useState<string>();
    const callPhoneRef = useRef<string>();

    /**
     * 通话状态
     * -1: 初始状态
     * 0 : 响铃
     * 1: 通话中
     */
    const [ringStatus, setRingStatus] = useState<number>(-1);
    // 呼入 / 呼出电话号
    const [phone, setPhone] = useState<string>();
    // 呼入队列名称
    const [qname, setQname] = useState<string>();
    // 是否是主动外呼
    // const [isDriving, setIsDriving] = useState<boolean>(false);
    const isDriving = useRef<boolean>(false);
    // 保留上次通话状态文案（呼叫类型文案、通话状态文案）
    const [drivingText, setDrivingText] = useState<string>();
    const [ringText, setRingText] = useState<string>();

    const [loading, setLoading] = useState<boolean>(false);

    // 通话中操作
    // 是否保持中
    const [holding, setHolding] = useState<boolean>(false);
    // 是否静音中
    const [muteing, setMuteing] = useState<boolean>(false);

    // 排队人数
    // const [queueList, setQueueList] = useState<any[]>([]);
    const [queueNum, setQueueNum] = useState<number>(0);
    const queueNumRef = useRef<number>(0);

    // 转队列弹窗
    const [showChangeQueue, setShowChangeQueue] = useState<boolean>(false);
    // 转坐席弹窗
    const [showTransferToMember, setShowTransferToMember] =
        useState<boolean>(false);

    // 是否接听
    const isAnswer = useRef(false);
    // 坐席状态计时器
    const statusTimerRef = useRef(null);
    // 通话状态计时器
    const RingTimerRef = useRef(null);

    useEffect(() => {
        getPausesStatus().then((res) => {
            // console.log(res);
            setPauseStatus(res.data);
        });
        window.softPhoneUtils = SoftPhoneUtils({
            ringing: (res) => {
                console.log('响铃', res);
                setRingText(intl.get('响铃时长'));
                isDriving.current = res.driving;
                changeStatus(0, res);
                // setDrivingText(softPhoneUtils.driving ? '');
                // FIX: 响铃之后记录 mainUniqueId
                // console.log(res.mainUniqueId);
            },
            busy: (res) => {
                // 通话中
                console.log('通话中');
                // action busyOb / busyIb 通话中
                // action hold 保持
                // const action = res.action || 'busyIb';
                // switch()
                setRingText(intl.get('通话中'));
                changeStatus(1, res);
            },
            wrapup: (res) => {
                // 挂断
                console.log('挂断');
                setRingText(
                    isAnswer.current
                        ? intl.get('通话时长')
                        : intl.get('响铃时长'),
                );
                console.log('-=-=-=', isAnswer.current);
                setStatus(res.agentStatus);
                changeStatus(-1, res);
            },

            changeStatus: (res) => {
                // 一般认为刚刚登陆成功，或者电话结束之后，切换回初始状态
                changeStatus(-1, res);
                setStatus(res.agentStatus);
                if (res.code === 'IDLE') {
                    // 空闲, 没有接通直接挂断各种情况，会直接到这里
                } else if (res.code === 'PAUSE') {
                    // 忙碌状态
                    console.log('-=-=--=');
                }
            },

            logout: (res) => {
                // 被动下线（单点登录掉线、网络原因掉线）
                logout(res.message);
            },
        });

        const hideKeyBoard = () => {
            setShowKeyBoard(false);
        };
        window.addEventListener('click', hideKeyBoard);

        return () => {
            window.removeEventListener('click', hideKeyBoard);
        };
    }, []);

    const changeStatus = useCallback(
        (status: number, data: any) => {
            setRingStatus(status);
            setLoading(false);
            console.log('状态变更===', status, data);
            switch (status) {
                case -1:
                    //  恢复初始状态
                    RingTimerRef.current?.regain();
                    RingTimerRef.current?.pause();
                    record();
                    setRingText(
                        isAnswer.current
                            ? intl.get('通话时长')
                            : intl.get('响铃时长'),
                    );
                    isDriving.current = false;
                    isAnswer.current = false;
                    setHolding(false);
                    setMuteing(false);
                    break;
                case 0:
                    //  响铃
                    isAnswer.current = false;
                    sessionId.current = data.mainUniqueId;
                    popId.current = data.customerNumber;
                    setPhone(data.customerNumber);
                    RingTimerRef.current?.resetTimer();

                    if (isDriving.current) {
                        setDrivingText(intl.get('外呼'));
                        setCallPhone(data.customerNumber);
                        callPhoneRef.current = data.customerNumber;
                    } else {
                        setDrivingText(intl.get('呼入'));
                        setQname(data.qname);
                        // 呼入弹屏
                        history.push(
                            `/online/${data.customerNumber}/${data.mainUniqueId}`,
                        );
                    }
                    break;
                case 1:
                    // 通话中
                    isAnswer.current = true;
                    setRingText(intl.get('通话中'));
                    RingTimerRef.current?.resetTimer();
                    break;
            }
        },
        [sessionId, phone],
    );

    // 功能方法
    const Functions = {
        changeShowKeyBoard: () => {
            setShowKeyBoard(!showKeyBoard);
        },
        sipLink: () => {
            // 接听
            window.softPhoneUtils?.sipLink().then((res) => {
                changeStatus(1, res);
            });
        },
        hangup: () => {
            Modal.confirm({
                title: intl.get('您是否要挂断本次通话'),
                onOk: () => {
                    window.softPhoneUtils
                        ?.hangup(ringStatus === 0)
                        .then((res) => {
                            setStatus(res.agentStatus);
                            changeStatus(-1, res);
                        });
                },
            });
        },
        call: () => {
            // 外呼
            if (!callPhoneRef.current) {
                message.warning(intl.get('请输入手机号之后外呼'));
                return;
            }

            window.softPhoneUtils
                ?.call({
                    tel: callPhoneRef.current,
                })
                .then(() => {
                    isDriving.current = true;
                    setLoading(true);
                });
        },
        hold: () => {
            // 保持
            setHolding(true);
            RingTimerRef.current?.recordAndReset();
            setRingText(intl.get('保持时长'));
            window.softPhoneUtils?.hold();
        },
        unhold: () => {
            // 取消保持
            setHolding(false);
            RingTimerRef.current?.regain();
            setRingText(intl.get('通话中'));
            window.softPhoneUtils?.unhold();
        },
        mute: () => {
            // 静音
            setMuteing(true);
            RingTimerRef.current?.recordAndReset();
            setRingText(intl.get('静音时长'));
            window.softPhoneUtils?.mute();
        },
        unmute: () => {
            // 取消静音
            setMuteing(false);
            RingTimerRef.current?.regain();
            setRingText(intl.get('通话中'));
            window.softPhoneUtils?.unmute();
        },
        //  转队列
        changQueue() {
            setShowChangeQueue(true);
        },
        // 转员工
        transferMember() {
            setShowTransferToMember(true);
        },
        // ...
    };

    // 所有功能方法调用公共方法，做一些前置校验
    const onFunctionClick = (e: React.MouseEvent, key: string) => {
        e.stopPropagation();
        if (!isLogin) return;

        // if (status !== '空闲') return;

        if (isFunction(Functions[key])) {
            Functions[key]();
        }
    };

    const onStateChange = ({ key }) => {
        if (key === intl.get('签出')) {
            // 退出登陆
            window.softPhoneUtils
                ?.logout()
                .then(() => {
                    logout();
                })
                .catch((res) => {
                    message.warning(res.msg);
                    return false;
                });
            return;
        }
        // setStatus(key);

        if (key === intl.get('空闲')) {
            statusTimerRef.current?.resetTimer();
            window.softPhoneUtils?.unpause();
            return;
        }

        const statusItem = pauseStatus.find((item) => item.pauseStatus === key);

        window.softPhoneUtils?.pause({
            pauseType: statusItem?.pauseType,
            pauseDescription: key,
        });

        statusTimerRef.current?.resetTimer();
    };

    const onKeydown = (e: React.MouseEvent, key: string | number) => {
        e.stopPropagation();
        console.log('keydown', key);
        window.softPhoneUtils?.keyDown(key);
    };

    const logout = (msg?: string) => {
        if (msg) {
            Modal.warn({
                title: intl.get('提示'),
                content: msg,
                onOk: () => {
                    // 刷新页面
                    window.location.reload();
                },
            });
            return;
        }

        setIsLogin(false);
        setPhone(undefined);
        sessionId.current = undefined;
        popId.current = undefined;
    };

    const onLogin = (params) => {
        setPhoneType(params.bindType);
        setIsLogin(true);
        setStatus(
            params.loginStatus === 1 ? intl.get('空闲') : params.loginStatus,
        );
        // setShowLoginConfig(false);
        // 获取坐席详情
        getAgentDetail(userInfo.jobNumber)
            .then((res) => {
                console.log('坐席详情', res);
                // setDetail(res.data);
                // 监控队列排队人数
                window.softPhoneUtils.registerQueueChange((type) => {
                    if (type === 'add') {
                        const num = queueNumRef.current + 1;
                        setQueueNum(num);
                        queueNumRef.current = num;
                    } else {
                        const num = queueNumRef.current - 1;
                        setQueueNum(num);
                        queueNumRef.current = num;
                    }
                });
                // 获取所在队列所有排队情况
                return getQueueStatus(res.data.qnos);
            })
            .then((res) => {
                console.log('队列排队人数', res);
                // setQueueList(res.data || []);
                const num = (res.data || []).reduce((accumulator, item) => {
                    return accumulator + item.queueEntries?.length || 0;
                }, queueNumRef.current);
                setQueueNum(num);
                queueNumRef.current = num;
            });
        // });
    };

    /**
     * 转队列
     * @param type 0：电话号码 1：座席工号 2：IP话机号 3：语音导航节点
     * @param values
     */
    const onTransfer = (type: number, values) => {
        setShowChangeQueue(false);

        let transferObject = '';
        if (type === 3) {
            transferObject = JSON.stringify(values);
        }

        if (type === 1) {
            transferObject = values.cno;
        }
        // FIX: 目前拿不到转移状态
        window.softPhoneUtils?.transfer({
            objectType: type,
            transferObject,
            hold: 0,
        });

        setShowChangeQueue(false);
        setShowTransferToMember(false);
    };

    /**
     * 请求接口，记录通话
     */
    const record = () => {
        if (sessionId.current && popId.current) {
            recordCall({
                sessionId: sessionId.current,
                sessionType: isDriving.current ? 2 : 3,
                popId: popId.current,
                // 这里获取可能有的工单号之类的额外参数，具体参数参考 useCall 写入的参数
                ...window.softPhoneUtils.getExtraData(),
            }).then((res) => {
                console.log(res);
            });
        }
    };

    return (
        <>
            <Space
                className={style.SoftPhoneContianer}
                size={10}
            >
                <div className={style.avatar}>
                    <div>
                        {userInfo.name}
                        {intl.get('工号')}
                        {userInfo.jobNumber}
                    </div>
                    {isLogin && (
                        <div className={style.timerContainer}>
                            <div
                                className={`${style.statusText} ${
                                    status === intl.get('空闲')
                                        ? style.green
                                        : style.red
                                }`}
                            >
                                {status}
                            </div>
                            <Timer ref={statusTimerRef} />
                        </div>
                    )}
                </div>

                <Status
                    currentStatus={status}
                    isLogin={isLogin}
                    pauseStatus={pauseStatus}
                    jobNumber={userInfo.jobNumber}
                    onLogin={onLogin}
                    onStateChange={onStateChange}
                ></Status>

                <div>
                    <Space.Compact>
                        <Input
                            size="small"
                            value={callPhone}
                            disabled={!isLogin}
                            placeholder={intl.get('请输入外呼号码')}
                            maxLength={11}
                            onChange={(e) => {
                                setCallPhone(e.target.value);
                                callPhoneRef.current = e.target.value;
                            }}
                        />

                        <div
                            className={`${style.functionItem} ${
                                !isLogin ? style.disabled : ''
                            }`}
                            onClick={(e) => {
                                onFunctionClick(e, 'changeShowKeyBoard');
                            }}
                        >
                            <Icon type="icon-bohaoxin"></Icon>
                            {intl.get('键盘')}

                            {showKeyBoard && <KeyBoard onClick={onKeydown} />}
                        </div>

                        {/* 只有软电话才可以操作接听, 外呼隐藏接听按钮 */}
                        {phoneType === 3 &&
                            ringStatus === 0 &&
                            !isDriving.current && (
                                <div
                                    className={`${style.functionItem} ${style.blink}`}
                                    onClick={(e) =>
                                        onFunctionClick(e, 'sipLink')
                                    }
                                >
                                    <Icon type="icon-jinxian1"></Icon>
                                    {intl.get('接听')}
                                </div>
                            )}
                        {/* 响铃 / 通话中 */}
                        {(ringStatus === 0 || ringStatus === 1) && (
                            <div
                                className={`${style.functionItem} ${style.highlight}`}
                                onClick={(e) => onFunctionClick(e, 'hangup')}
                            >
                                <Icon type="icon-guaduan_xin"></Icon>
                                {intl.get('挂断')}
                            </div>
                        )}
                        {ringStatus === -1 && (
                            <Spin
                                spinning={loading}
                                size="small"
                            >
                                <div
                                    className={`${style.functionItem} ${
                                        !isLogin ? style.disabled : ''
                                    }`}
                                    onClick={(e) => onFunctionClick(e, 'call')}
                                >
                                    <Icon type="icon-waihu"></Icon>
                                    {intl.get('呼叫')}
                                </div>
                            </Spin>
                        )}
                    </Space.Compact>
                </div>

                {/* 通话中，展示可操作按钮 */}
                {isLogin && ringStatus === 1 && (
                    <ul className={style.functions}>
                        {!muteing && (
                            <li
                                className={`${style.functionItem} ${
                                    holding && style.active
                                }`}
                                onClick={(e) =>
                                    onFunctionClick(
                                        e,
                                        holding ? 'unhold' : 'hold',
                                    )
                                }
                            >
                                {holding ? (
                                    <span>
                                        <Icon type="icon-quxiaobaochi_xin"></Icon>
                                        {intl.get('取消保持')}
                                    </span>
                                ) : (
                                    <span>
                                        <Icon type="icon-baochi_xin"></Icon>
                                        {intl.get('保持')}
                                    </span>
                                )}
                            </li>
                        )}
                        {!holding && (
                            <li
                                className={`${style.functionItem}  ${
                                    muteing && style.active
                                }`}
                                onClick={(e) =>
                                    onFunctionClick(
                                        e,
                                        muteing ? 'unmute' : 'mute',
                                    )
                                }
                            >
                                <Icon type="icon-jingyin"></Icon>
                                {muteing
                                    ? intl.get('取消静音')
                                    : intl.get('静音')}
                            </li>
                        )}

                        {!holding && !muteing && (
                            <li
                                className={`${style.functionItem}`}
                                onClick={(e) =>
                                    onFunctionClick(e, 'changQueue')
                                }
                            >
                                <Icon type="icon-zhuanduilie_xin"></Icon>
                                {intl.get('转队列')}
                            </li>
                        )}

                        {!holding && !muteing && (
                            <li
                                className={style.functionItem}
                                onClick={(e) =>
                                    onFunctionClick(e, 'transferMember')
                                }
                            >
                                <Icon type="icon-zhuanjie"></Icon>
                                {intl.get('转移')}
                            </li>
                        )}
                    </ul>
                )}

                {isLogin && phone && (
                    <div className={style.ringContainer}>
                        <div>
                            {phone} （{drivingText}）
                            <div
                                className={`${style.timerContainer} ${
                                    ringStatus === 1 && style.active
                                } ${(holding || muteing) && style.warning}`}
                            >
                                {ringText || intl.get('通话时长')}:
                                <Timer ref={RingTimerRef} />
                            </div>
                        </div>

                        {qname && <div>{qname}</div>}
                    </div>
                )}
                {isLogin && (
                    <div className={style.queueNum}>
                        {intl.get('排队')}
                        <span className={style.num}>{queueNum}</span>
                        {intl.get('人')}
                    </div>
                )}
            </Space>

            <TransferToNode
                show={showChangeQueue}
                onClose={() => setShowChangeQueue(false)}
                onSave={(values) => {
                    /**
                     * 0：电话号码
                     *   1：座席工号
                     *   2：IP话机号
                     *   3：语音导航节点
                     */
                    onTransfer(3, values);
                }}
            />

            <TransferToMember
                show={showTransferToMember}
                onClose={() => setShowTransferToMember(false)}
                onSave={(values) => {
                    onTransfer(1, values);
                }}
            />
        </>
    );
};

export default SoftPhone;
